export default __webpack_public_path__ + "static/media/vet-bills.861e325a.svg";